import React from "react";
import { Header, Icon, Container, Button } from "semantic-ui-react";

const RecoverCompleted = () => {
  return (
    <Container textAlign="center">
      <br />
      <br />
      <Icon name="check circle outline" color="yellow" size="huge" />
      <Header as="h1" color="blue" size="huge">
        ¡Felicitaciones!
      </Header>
      <Header as="h4" color="blue" size="tiny">
        Tu contraseña fue actualizada satisfactoriamente{" "}
      </Header>
      <br />
      <br />
      <br />
      <Button
        onClick={() => (window.location = "/login")}
        color="yellow"
        size="large"
        content="Iniciar Sesión"
      />
      <Container></Container>
    </Container>
  );
};
export default RecoverCompleted;
